export enum PatientDiagnosisBehaviorEnum {
    All = "all",
    Current = "current"
}
